/// <amd-module name="Search/WorkItem/Components/Splitter" />
import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { Orientation, Position, Sized, Sizer } from "VSSUI/Sizer";
import { LeftPaneContainer } from "Search/WorkItem/Components/LeftPane/LeftPane";
import { RightPaneContainer } from "Search/WorkItem/Components/RightPane/RightPane";
import { PreviewOrientationActionIds } from "Search/WorkItem/Constants";
import { ActionCreator } from "Search/WorkItem/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/WorkItem/Flux/StoresHub";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { css } from "VSS/Platform/Layout";

export const SplitterContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    [
        "previewOrientationStore"
    ],
    ({
        previewOrientationStoreState
    }, props) => {
        const { previewOrientation, splitterSize } = previewOrientationStoreState;
        const splitterDirection = previewOrientation === PreviewOrientationActionIds.Bottom ? Orientation.column : Orientation.row;
        let className: string;
        let height: IReadonlyObservableValue<number> | undefined;
        let width: IReadonlyObservableValue<number> | undefined;
        const MinRightPaneWidth = 0.40;
        const MarginAdjustment = 20;
        const MaxSplitterSize = MinRightPaneWidth * (document.body.clientWidth - MarginAdjustment);

        if (props.storesHub.searchStore.isEmptyResponse()) {
            return (<div></div>);
        }

        if (splitterDirection === Orientation.column) {
            className = "flex-column";
            height = splitterSize;
        } else {
            className = "flex-row";
            width = splitterSize;
        }

        return (
            <div className={css("flex-grow scroll-hidden relative", className)}>
                <Sized className="flex-column scroll-hidden set-width-on-zoom" height={height} width={width}>
                    <LeftPaneContainer {...props} />
                </Sized>
                <Sizer
                    id="work-item-results-pane-sizer"
                    minSize={280}
                    maxSize={MaxSplitterSize}
                    onSize={(event, updatedSize: number) => splitterSize.value = updatedSize}
                    onSizeEnd={() => props.actionCreator.changeSplitterFixedSize(splitterSize.value)}
                    orientation={splitterDirection}
                    position={Position.near}
                    size={splitterSize}
                    tabIndex={0}
                />
                <RightPaneContainer {...props} />
            </div>
        );
    });
